"use client";

import { useEffect } from "react";

/* Scroll slide-up reveal, scoped to .cx-page */
export default function CxoReveal() {
  useEffect(() => {
    const root = document.querySelector(".cx-page");
    if (!root) return;
    root.classList.add("cx-js");
    const els = root.querySelectorAll<HTMLElement>(".cx-reveal, .cx-stagger, .cx-card");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return null;
}
